import { render, staticRenderFns } from "./ProblemPart.vue?vue&type=template&id=70bfb9a6&scoped=true&"
import script from "./ProblemPart.vue?vue&type=script&lang=js&"
export * from "./ProblemPart.vue?vue&type=script&lang=js&"
import style0 from "./ProblemPart.vue?vue&type=style&index=0&id=70bfb9a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bfb9a6",
  null
  
)

export default component.exports